import { render, staticRenderFns } from "./SidebarLink.vue?vue&type=template&id=62f945f6&"
import script from "./SidebarLink.vue?vue&type=script&lang=js&"
export * from "./SidebarLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1983107846/src/bitbucket.org/atsuboi/chatbot/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62f945f6')) {
      api.createRecord('62f945f6', component.options)
    } else {
      api.reload('62f945f6', component.options)
    }
    module.hot.accept("./SidebarLink.vue?vue&type=template&id=62f945f6&", function () {
      api.rerender('62f945f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SidebarPlugin/SidebarLink.vue"
export default component.exports